






































import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'

@Component
export default class TrackingNumberModal extends Vue {
  @Prop({ type: Object, default: () => null })
  selectedItem: any

  trackingNumber = null

  show = false

  showDatepicker = false

  date: string | null = null

  get displayDate() {
    if (!this.date) {
      return null
    }

    return new Date(this.date).toLocaleDateString()
  }

  mounted() {
    this.$nextTick().then(() => {
      const today = new Date()
      this.date = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`
    })
  }

  public requiredRule(text: string) {
    return !!text || 'Value is required'
  }

  async markAsShipped() {
    let data: any = { item: this.selectedItem, trackingNumber: this.trackingNumber }

    if (this.date) {
      data.shippedDate = new Date(this.date)
    }

    this.$emit('ship', data)
    this.show = false
  }

  public open() {
    this.show = true
  }
}
